module.exports = __webpack_public_path__ + "img/9.08b9c80a.png";